import { SearchForm } from "mixs/base/search_mixin";
import { PlannerSearch } from "mixs/forms/planner/search";
import { get } from "apps/actions/common"

class Search extends PlannerSearch {
  protected getNewURI(query){
    if(query == '') return this.opts.action;
    let next    = this.opts.action + '?' + query;
    return next;
  }
}

riot.mixin("forms.orders.search-for-csv", Search as riot.TagMixin);
